import {
    SET_CLUB,
    SET_LISTE_FORMATION,
    SET_LISTE_CLUB,
} from './mutations-type'

var _ = require('underscore');

// initial state
const state = {
    club:null,
    liste_club:[],
}

// mutations
const mutations = {
    [SET_CLUB](state,message) {
        state.club=message;
    },
    [SET_LISTE_CLUB](state, message) {
        state.liste_club = message;
    },
}

const actions = {
    setClub({commit},msg) {
        commit(SET_CLUB,msg)
    },
    setListeClub({commit}, msg) {
        commit(SET_LISTE_CLUB, msg)
    },
}

const getters = {
    getClub: state => {
        return state.club;
    },
    getListeClub: state => {
        return state.liste_club;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/vuex/store-club.js